import { HighlightsModal } from "#components";
import type { ICirrusReaderHighlightData } from "../shared/CirrusReaderModel";

const overlay = useOverlay()
const modal = overlay.create(HighlightsModal)
interface ModalOptions {
    highlight: ICirrusReaderHighlightData
}
export function useHighlightsModal() {
    function openModal(options: ModalOptions) {
        const result = modal.open(options).result;
        return result;
    }

    return {
        modal,
        openModal
    }
}